import React from 'react';
import { Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ButtonSection = ({ onClose}:any) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const {t}= useTranslation()

  return (
    <div className="text-end mt-3">
      <Button 
        color="secondary" 
        className="me-2" 
        onClick={onClose}
      >
        {t("Cancel")}
      </Button>
      <Button 
        color="primary" 
        type="submit"
      >
         {id ? t("UpdateOrganization") : t("AddOrganization")}
      </Button>
    </div>
  );
};

export default ButtonSection;